<div>
  <!-- <div style="width: 0%; height: 100%">
    <textarea style="width: 100%; height: 100vh" type="text" [(ngModel)]="jsonData"></textarea>
  </div>  -->
  <div class="tx-pdf-viewer" style="width: 100%; height: 100%">
    <tx-header
      [editorMeta]="document"
      [isDirty]="isDirty"
      [initials]="initials"
      (onLogout)="logout()"
      (onSave)="save()"
      (onPrint)="printDocument()"
      (onDownload)="downloadDocument()"></tx-header>

      <tx-loader *ngIf="loadingService.loading" [loadingAction]="loadingService.loadingAction" [isPdf]="true"></tx-loader>
      
      <ngx-extended-pdf-viewer
      *ngIf="base64Doc != '' && base64Doc != null"
      [base64Src]="base64Doc"
      [customToolbar]="customToolbar"
      [customFreeFloatingBar]="floatingZoomBar"
      [showFreeFloatingBar]="true"

      [(zoom)]="zoom"
      [(formData)]="formData"
      [handTool]="false"
      [ignoreKeyboard]="false"
      [ignoreKeys]="['CTRL+S', 'CTRL+O', 'CTRL+P']"
      (formDataChange)="onFormDataChange($event)"
      [enableDragAndDrop]="false"
      (pagesLoaded)="onPdfLoadedHandler()"
      (pageRendered)="onPageRendered($event)">
    </ngx-extended-pdf-viewer>
    <!-- for debugging
      [minifiedJSLibraries]="false" -->
    <ng-template #customToolbar>
      <nav class="flex-container">
        <button type="button" (click)="onFileClicked()" #fileButton>File</button>
      </nav>
      <div>
        <div class="ribbon-bar">
          <div class="ribbon-group ribbon-group-search">
            <div class="ribbon-group-content">
              <pdf-find-button [showFindButton]="true" [textLayer]="true"></pdf-find-button>
            </div>
            <div class="ribbon-group-label position-static">Search</div>
          </div>
          <div class="ribbon-group">
            <div class="ribbon-group-content">
              <pdf-paging-area></pdf-paging-area>
            </div>
            <div class="ribbon-group-label position-static">Pagination</div>
          </div>
          <tx-pdf-section-portal></tx-pdf-section-portal>
        </div>
      </div>
      <div
        *ngIf="hasJSError"
        @fadeInOut
        class="pdf-JS-error p-2 vw-100 position-absolute d-flex justify-content-center align-items-center"
        style="background-color: rgba(255, 243, 205, 0.9); height: calc(100vh - 150px)">
        <div class="p-4 bg-light-subtle border" style="width: 300px; height: 150px">
          <p class="text-center w-100">There was an error processing this PDF document.</p>
          <p class="text-center w-100">Our Tech Support has been notified.</p>
          <p class="text-center w-100"><strong>Please edit this form in TXdocs,</strong></p>
          <p class="text-center w-100"><strong>we are sorry for this inconvenience.</strong></p>
        </div>
      </div>
    </ng-template>

    <ng-template #floatingZoomBar>
      <footer class="d-flex justify-content-end"> <!-- class="d-flex justify-content-end me-3" -->
        <tx-zoom-slider (onZoomUpdate)="updateZoomFactor($event)"></tx-zoom-slider>
      </footer>
    </ng-template>
  </div>
  <div id="plugContainer">
    <div
      *ngIf="documentDisconnectedFromTXdocsAnswerPool"
      class="div-plug plug-off"
      title="Changes to answers will be saved in the document but will not be saved to the case in TXdocs">
      <div class="icon-container">
        <span class="bar-left"></span>
        <span class="disconnected-text">Disconnected</span>
        <i class="bi bi-plugin"></i>
        <span class="bar-right"></span>
        <!--WiP: styling of disconnected text and strikethrough line-->
      </div>
      <span *ngIf="documentDisconnectedFromTXdocsAnswerPool" class="strikethrough-line"></span>
    </div>
    <div
      *ngIf="!documentDisconnectedFromTXdocsAnswerPool"
      class="div-plug"
      title="Changes to answers will be saved in the document and to the case in TXdocs">
      <div class="icon-container">
        <span class="bar-left"></span>
        <i class="bi bi-plugin"></i>
        <span class="bar-right"></span>
      </div>
    </div>
  </div>
</div>
